import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import AlertIcon from '@assets/img/icons/alert.svg?react';
import { StringSmall } from '@components/Typography/Typography';
import { Button, MainSmButton } from '@components/ui/Button/Button';
import { Container } from '@components/ui/Container/container';
import cn from 'classnames';

import { gameItemOrder } from '@/common/constants';
import { selectIsGameItemHasOverflow } from '@/redux/selectors/userSelectors';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

interface StorageNavigationProps {
  activeIndex: number;
  changeSlide: (num: number) => void;
}

const StorageNavigation = forwardRef<HTMLDivElement, StorageNavigationProps>(
  ({ activeIndex, changeSlide }, ref) => {
    const { t } = useTranslation();
    const someResourceHasOverflow = useAppSelector((state) =>
      selectIsGameItemHasOverflow(state, gameItemOrder.resource),
    );
    const someMaterialHasOverflow = useAppSelector((state) =>
      selectIsGameItemHasOverflow(state, gameItemOrder.material),
    );
    const someGoodsHasOverflow = useAppSelector((state) =>
      selectIsGameItemHasOverflow(state, gameItemOrder.goods),
    );

    const overflow: Record<string, boolean> = {
      'Resources': someResourceHasOverflow,
      'Materials': someMaterialHasOverflow,
      'Goods': someGoodsHasOverflow,
    };

    return (
      <div ref={ref} className={css.navigation}>
        <Container variant="task" className="flex items-center h-8">
          {['Resources', 'Materials', 'Goods'].map((label, index) =>
            index === activeIndex ? (
              <MainSmButton
                className="flex-1 h-full text-center relative"
                text={t(label)}
              >
                {overflow[label] && (
                  <AlertIcon
                    className={cn(
                      'absolute top-[2px] right-[2px] w-4 h-4',
                      css.dropShadow,
                    )}
                  />
                )}
              </MainSmButton>
            ) : (
              <Button
                onClick={() => changeSlide(index)}
                className="flex-1 h-full text-center relative"
                variant="transparent"
              >
                {overflow[label] && (
                  <AlertIcon className="absolute top-[2px] right-[2px] w-4 h-4" />
                )}
                <StringSmall weight="bold" className="text-white/40">
                  {t(label)}
                </StringSmall>
              </Button>
            ),
          )}
        </Container>
      </div>
    );
  },
);

export { StorageNavigation };
